// extracted by mini-css-extract-plugin
var _1 = "MenuSection-moduleMenuSection__XsaG0";
export { _1 as "MenuSection" }
